
export enum DesignType {
   BADGE= 0,
   TICKET
}
